import React from "react";

const WorkProcessThree = () => {
  return (
    <>
      {/*==================== Work Process Three start ====================*/}
      <div className='work-process-area pd-top-120 pd-bottom-90'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-xl-7 col-lg-9'>
              <div className='section-title text-center'>
                <h6 className='sub-title'>CREATIVE MEMBERS</h6>
                <h2 className='title'>
                  The Best Development <span>Solutions</span> In The Country
                </h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-3 text-center'>
                <h2 className='process-count mb-2 color-base'>01.</h2>
                <h5 className='mb-4'>Zero to app in no time</h5>
                <img src='assets/img/testimonial/6.png' alt='img' />
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-3 text-center'>
                <h2 className='process-count mb-2 color-base'>02.</h2>
                <h5 className='mb-4'>Zero to app in no time</h5>
                <img src='assets/img/testimonial/7.png' alt='img' />
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-3 text-center'>
                <h2 className='process-count mb-2 color-base'>03.</h2>
                <h5 className='mb-4'>Zero to app in no time</h5>
                <img src='assets/img/testimonial/8.png' alt='img' />
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-3 text-center'>
                <h2 className='process-count mb-2 color-base'>04.</h2>
                <h5 className='mb-4'>Zero to app in no time</h5>
                <img src='assets/img/testimonial/9.png' alt='img' />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== Work Process Three end ====================*/}
    </>
  );
};

export default WorkProcessThree;
